// Worked examples for the Rollout Readout. All counts are synthetic.
// Addressable as #example=<id>.

export const EXAMPLES = [
  {
    id: "onboarding-before-after",
    name: "New onboarding, before and after",
    description: "Eight weeks before the launch measure the usual swing; four weeks after. Synthetic.",
    state: {
      mode: "before-after",
      history: "110/400\n93/383\n98/384\n100/417\n102/383\n93/385\n95/407\n108/415",
      afterPeriods: 4,
      eventLabel: "activations",
      exposureLabel: "signups",
      base: { events: 412, exposure: 1630 },
      test: { events: 489, exposure: 1702 },
      driftPct: 0,
      higherIsBetter: true,
      targetPct: 5,
    },
  },
  {
    id: "random-accounts",
    name: "Rollout to accounts picked at random",
    description: "Half the accounts got the feature first, chosen by a hash of their id. Synthetic.",
    state: {
      mode: "randomized",
      history: "",
      afterPeriods: 1,
      eventLabel: "exports",
      exposureLabel: "account-weeks",
      base: { events: 380, exposure: 1200 },
      test: { events: 452, exposure: 1180 },
      driftPct: 0,
      higherIsBetter: true,
      targetPct: 5,
    },
  },
  {
    id: "support-tickets",
    name: "Support tickets after a redesign",
    description: "Fewer is better; no weekly history, so the range rests on a judged allowance. Synthetic.",
    state: {
      mode: "before-after",
      history: "",
      afterPeriods: 1,
      eventLabel: "support tickets",
      exposureLabel: "active-user weeks",
      base: { events: 96, exposure: 5200 },
      test: { events: 81, exposure: 5350 },
      driftPct: 15,
      higherIsBetter: false,
      targetPct: 10,
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
